import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Typography, Grid } from "@mui/material";
import CarrierProfileEquipment from "../CarrierProfileEquipment/CarrierProfileEquipment";
import CarrierProfileCapabilityTypes from "./CarrierProfileCapabilityTypes/CarrierProfileCapabilityTypes";

export default function CarrierProfileAttributesContainer({
  activeCarrier,
  setActiveCarrier,
  isUpdating, 
  setIsUpdating
}) {
  const [allAccessoryTypes, setAllAccessoryTypes] = useState({});
  const [allServiceTypes, setAllServiceTypes] = useState({});
  const [allCargoTypes, setAllCargoTypes] = useState({});

  useEffect(() => {
    if (activeCarrier.trailerAccessories){
      setAllAccessoryTypes(activeCarrier.trailerAccessories);
    }

    if (activeCarrier.services) {
      setAllServiceTypes(activeCarrier.services);
    }

    if (activeCarrier.cargoTypes) {
      setAllCargoTypes(activeCarrier.cargoTypes);
    }
  }, [activeCarrier]);

  return (
    <Box className="Carrier-profile-component" sx={{ height: "calc(100vh - 400px)", overflow: "scroll" }}>
      <Box className="Carrier-profile-component-header">
        <Typography variant="h3" color="black_opacity.100">
          Attributes
        </Typography>
      </Box>
      <Grid container sx={{ padding: "0 24px 12px 24px" }}>
        <Grid item xs={3}>
          <CarrierProfileEquipment activeCarrier={activeCarrier}/>
        </Grid>
        <Grid item xs={3}>
          <CarrierProfileCapabilityTypes
            typeName="Trailer Accessories"
            allTypes={allAccessoryTypes}
            activeCarrier={activeCarrier}
            setActiveCarrier={setActiveCarrier}
            isUpdating={isUpdating}
            setIsUpdating={setIsUpdating}
          />
        </Grid>
        <Grid item xs={3}>
          <CarrierProfileCapabilityTypes
            typeName="Service Types"
            allTypes={allServiceTypes}
            activeCarrier={activeCarrier}
            setActiveCarrier={setActiveCarrier}
            isUpdating={isUpdating}
            setIsUpdating={setIsUpdating}
          />
        </Grid>
        <Grid item xs={3}>
          <CarrierProfileCapabilityTypes
            typeName="Cargo Types"
            allTypes={allCargoTypes}
            activeCarrier={activeCarrier}
            setActiveCarrier={setActiveCarrier}
            isUpdating={isUpdating}
            setIsUpdating={setIsUpdating}
          />
        </Grid>
      </Grid> 
    </Box>
  );
}

CarrierProfileAttributesContainer.propTypes = {
  activeCarrier: PropTypes.object.isRequired,
  setActiveCarrier: PropTypes.func.isRequired,
  isUpdating: PropTypes.bool.isRequired,
  setIsUpdating: PropTypes.func.isRequired
};